export default __webpack_public_path__ + "static/media/collection_categories_card.7fa7a151.jpg";